import { createFileRoute, redirect } from "@tanstack/react-router";

import { ResetPassword } from "../../pages/Auth/ResetPassword";
import { useStore } from "../../store/store";

export const Route = createFileRoute("/auth/reset-password")({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: search.token as string | undefined,
    };
  },
  beforeLoad: ({ search, location }) => {
    if (search.token) {
      useStore.getState().setResetToken(search.token);
      redirect({
        to: location.pathname,
        replace: true,
        throw: true,
      });
    }
  },
  component: ResetPassword,
});
